<template>
  <section>
    <div class="mt-6">
      <virtual-account-table
        :tableData="customersVirtualAccountInfo"
        :page="page"
        :isLoading="isLoading"
      />
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      isLoading: false,
      payload: {
        page: 1,
        size: 10,
        customerId: '',
        status: ''
      }
    }
  },
  components: {
    VirtualAccountTable: () =>
      import('@/components/v2/externalApi/tables/VirtualAccountTable.vue')
    // ArrowDownIcon: () => import('@/assets/v2/icons/ArrowDownTwo.vue'),
    // FilterIcon: () => import('@/assets/v2/icons/FilterIcon.vue')
  },
  computed: {
    customersVirtualAccountInfo () {
      return this.$store.state.externalApi.customerVirtualAccount.items || []
    },
    page () {
      return this.$store.state.externalApi.customerVirtualAccount.page || {}
    }
    // commented out pending BE updates and we can pass status(Lade to update -create reusable tab component)
    // accountStatusCategories () {
    //   return [
    //     {
    //       name: 'All Accounts',
    //       isActive: this.activeCategory === 'All Accounts',
    //       count: this.page.totalCount,
    //       isDisplayed: true
    //     },
    //     {
    //       name: 'Active Account',
    //       isActive: this.activeCategory === 'active',
    //       count: this.page.totalCount,
    //       isDisplayed: true
    //     },
    //     {
    //       name: 'Inactive Account',
    //       isActive: this.activeCategory === 'inactive',
    //       count: this.page.totalCount,
    //       isDisplayed: true
    //     }
    //   ]
    // }
  },
  methods: {
    async getCustomerVirtualAccount () {
      const customer_Id = this.$route.params.id
      this.payload.customerId = customer_Id
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('externalApi/getCustomerVirtualAccount', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  mounted () {
    this.getCustomerVirtualAccount()
  }
}
</script>
<style scoped>
>>> .el-tooltip__popper.is-dark,
>>> .el-tooltip__popper.is-light,
>>> .el-tooltip__popper {
  background: white !important;
}

>>> .el-table {
  padding: 0;
  background: transparent;
  border-collapse: separate;
}

>>> .el-table table {
  border-spacing: 0 16px;
}

>>> .el-table th {
  border: none !important;
  background: #f7f7f7;
  padding: 0;
}

>>> .el-table tr {
  background: white;
  border-radius: 8px;
}
>>> .el-table tr:hover {
  cursor: pointer;
}
>>> .el-table td {
  border-bottom: none !important;
  background: white;
}

>>> .el-table td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
>>> .el-table td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

>>> .el-table::before {
  height: 0px;
}
>>> .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: white !important;
}
>>> .el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.disabled {
  background: green !important;
}
>>> .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: transparent !important;
  border: 0.941331px solid rgba(207, 219, 213, 0.7);
  border-radius: 7.53065px;
}
>>> .el-pagination.is-background .btn-prev,
.el-pagination.is-background .btn-next,
.el-pagination.is-background .el-pager li {
  background: transparent !important;
  border: 0.941331px solid rgba(207, 219, 213, 0.7);
  border-radius: 7.53065px;
}
>>> .el-input--prefix .el-input__inner {
  border: 1px solid var(--border-1);
  border-radius: 8px;
  background: var(--background-10);
}
>>> .el-tooltip__popper.is-light {
  background: white !important;
}
</style>
